import forms from "@/mixins/forms.js";
export default {
    mixins: [forms],
    components: {
        AutocompletePacientes: () =>
            import("@/components/forms/autocompletes/AutocompletePacientes.vue"),
        AutocompleteServicios: () =>
            import("@/components/forms/autocompletes/AutocompleteServicios.vue"),
        AutocompleteUsuarios: () =>
            import("@/components/forms/autocompletes/AutocompleteUsuarios.vue"),
        DatePicker: () => import("@/components/forms/pickers/DatePicker.vue"),
        TimePicker: () => import("@/components/forms/pickers/TimePicker.vue"),
    },
    data() {
        return {
            citas: [],
            showDialogCita: false,
            showDialogDeleteCita: false,
            cita: {
                id_cit: null,
                id_pac_cit: null,
                id_usr_cit: null,
                fecha_cit: null,
                hora_cit: null,
                estatus_cit: "programada",
                created_cit: null,
                servicios: [],
                feriado_cit: 'no',
            },
            serviciosConCantidad: [], // Almacenar servicios con cantidad
            procesandoServiciosDetalle: false, // Bandera para evitar loop infinito
            errors: {
                id_pac_cit: null,
                id_usr_cit: null,
                fecha_cit: null,
                hora_cit: null,
            },
        }
    },
    methods: {
        _preSaveCita() {
            if (this.cita.feriado_cit == 'si' || this._validateAll("cita")) {
                // Preparar los servicios con cantidad para el backend
                const serviciosParaBackend = this.serviciosConCantidad.map(servicio => ({
                    id_servicio: servicio.id_ser,
                    qty: servicio.qty || servicio.cantidad || 1,
                    precio: servicio.precio_ser
                }));
                
                const data = {
                    cita: this.cita,
                    servicios: serviciosParaBackend.length > 0 ? serviciosParaBackend : this.cita.servicios,
                };
                
                console.log('Datos a enviar al backend:', data);
                
                this.cita.id
                    ? this._updateAll(
                        "citas/" + this.cita.id,
                        data,
                        "msg",
                        "_citaSavedUpdated"
                    )
                    : this._saveAll("citas", data, "id", "_citaSavedUpdated");
            } else {
                this.$emit("msg", this.$lleneCampos);
            }
        },
        handleServiciosConCantidad(servicios) {
            // Guardar los servicios con cantidad para usarlos al guardar
            this.serviciosConCantidad = servicios;
        },
        async _procesarServiciosDetalle(serviciosDetalle) {
            if (!serviciosDetalle || serviciosDetalle.length === 0) {
                return;
            }
            
            // Activar bandera para evitar loop infinito
            this.procesandoServiciosDetalle = true;
            
            // Extraer los IDs de servicios para el v-model del autocomplete
            const idsServicios = serviciosDetalle.map(s => s.id_servicio);
            
            // Esperar a que el componente hijo esté listo y tenga servicios cargados
            const esperarServicios = () => {
                return new Promise((resolve) => {
                    const checkInterval = setInterval(() => {
                        const autocompleteServicios = this.$refs.autocompleteServicios;
                        if (autocompleteServicios && autocompleteServicios.servicios && autocompleteServicios.servicios.length > 0) {
                            clearInterval(checkInterval);
                            resolve(autocompleteServicios.servicios);
                        }
                    }, 100);
                    
                    // Timeout después de 5 segundos
                    setTimeout(() => {
                        clearInterval(checkInterval);
                        resolve([]);
                    }, 5000);
                });
            };
            
            try {
                // Esperar a que los servicios estén cargados
                const todosLosServicios = await esperarServicios();
                
                if (todosLosServicios.length === 0) {
                    this.procesandoServiciosDetalle = false;
                    return;
                }
                
                // Crear el array de servicios con cantidad
                this.serviciosConCantidad = serviciosDetalle.map(servDet => {
                    const servicioCompleto = todosLosServicios.find(s => s.id_ser === servDet.id_servicio);
                    if (servicioCompleto) {
                        // Parsing más robusto
                        let cantidad = 1;
                        if (servDet.qty) {
                            cantidad = parseInt(String(servDet.qty).trim()) || 1;
                        }
                        
                        return {
                            ...servicioCompleto,
                            cantidad: cantidad,
                            qty: cantidad
                        };
                    }
                    return null;
                }).filter(s => s !== null);
                
                // Activar bandera para evitar que el watcher del componente hijo interfiera
                if (this.$refs.autocompleteServicios) {
                    this.$refs.autocompleteServicios.cargandoInicial = true;
                }
                
                // Actualizar el v-model y el componente hijo
                this.cita.servicios = idsServicios;
                
                this.$nextTick(() => {
                    if (this.$refs.autocompleteServicios) {
                        // Crear una copia completamente nueva del array
                        const serviciosNuevos = this.serviciosConCantidad.map(servicio => ({
                            ...servicio,
                            cantidad: parseInt(servicio.cantidad),
                            qty: parseInt(servicio.qty)
                        }));
                        
                        // Asignar la nueva referencia
                        this.$refs.autocompleteServicios.serviciosConCantidad = serviciosNuevos;
                        
                        // Forzar actualización
                        this.$refs.autocompleteServicios.$forceUpdate();
                        
                        // Desactivar bandera para permitir futuras actualizaciones
                        this.$refs.autocompleteServicios.cargandoInicial = false;
                    }
                    
                    // Desactivar bandera después de procesar
                    this.procesandoServiciosDetalle = false;
                });
            } catch (error) {
                this.procesandoServiciosDetalle = false;
            }
        },
        _citaSavedUpdated(res) {
            if ("msg" in res) {
                this.$emit("msg", res.msg);
                this.$emit('refresh', true)
                this.$emit('id', this.cita.id ? this.cita.id_cit : res.id_cit)
                this.showDialogDeleteCita = false;
                this.showDialogCita = false;
            } else {
                this.$emit("msg", res.error);
            }
        },
        _checkIfFeriado() {
            if (this.cita.feriado_cit === "si") {
                this.cita.estatus_cit = "feriado";
                this.cita.hora_cit = '00:00:01';
                this.cita.id_pac_cit = -1;
                this.cita.id_usr_cit = -1;
            } else {
                this.cita.estatus_cit = "programada";
                this.cita.hora_cit = null;
                this.cita.id_pac_cit = null;
                this.cita.id_usr_cit = null;
            }
        },
        _deleteCita(idCit) {
            this._deleteAll('citas/' + idCit, 'msg', '_citaSavedUpdated')
        },
    },
    watch: {
        showDialogCita(a) {
            if (a && !this.cita.id) {
                this.showDialogDeleteCita = false
                this.cita.fecha_cit = this.$Datetime.now().toISODate();
            } else {
                this._limpiarCampos('cita')
            }
            this.cita.id_pac_cit = this.paciente.id_pac
            this.$emit("input", a);
        },
        'cita.id_cit': {
            handler(newVal) {
                // Cuando se carga una cita existente, esperar y procesar servicios_detalle
                if (newVal && this.cita.servicios_detalle && Array.isArray(this.cita.servicios_detalle)) {
                    console.log('Cita cargada, esperando componente hijo:', this.cita.servicios_detalle);
                    // Esperar más tiempo para asegurar que el componente hijo esté listo
                    setTimeout(() => {
                        this._procesarServiciosDetalle(this.cita.servicios_detalle);
                    }, 500);
                }
            }
        }
    },
}